<!--
 * @Author: your name
 * @Date: 2021-04-08 15:21:02
 * @LastEditTime: 2021-04-16 09:59:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/IndexList.vue
-->

<template>
  <Nav-bar :has_back="true" :has_right="false" title="开具发票"></Nav-bar>
  <div class="top-margin"></div>
  <van-empty
    description="暂无可开具的发票"
    v-if="state.ordersList.length == 0"
  />
  <div class="container" v-else>
    <van-index-bar :index-list="indexList" :sticky-offset-top="45">
      <div v-for="(tl, index) in monthList" :key="tl">
        <van-index-anchor @click="selectMonth(index)">
          <div class="title-container">
            <block>
              <img
                src="@/images/payment_unselected.png"
                class="select-icon"
                v-if="!state.ordersList[index].isMonthSelect"
              />
              <img
                src="@/images/payment_selected.png"
                class="select-icon"
                v-if="state.ordersList[index].isMonthSelect"
              />
            </block>
            <img src="@/images/receipt_calendar.png" class="date-icon" />
            <span class="t-f14-c0082FF m-l-10">{{ tl }}</span>
          </div>
        </van-index-anchor>
        <div
          class="item-container"
          v-for="(order, jndex) in state.ordersList[index].data"
          :key="order"
          @click="selectItem(index, jndex)"
        >
          <div class="time-v">
            <block>
              <img
                src="@/images/payment_unselected.png"
                class="select-icon"
                v-if="!state.ordersList[index].data[jndex].isItemSelected"
              />
              <img
                src="@/images/payment_selected.png"
                class="select-icon"
                v-if="state.ordersList[index].data[jndex].isItemSelected"
              />
            </block>
            <span class="t-f14-c1a m-l-10">{{
              $filters.timeFormate(order.completed_at)
            }}</span>
          </div>
          <div class="line" />
          <div class="orders-info">
            <span class="t-f16-c1a font-bold">{{
              order.charge_station_name
            }}</span>
            <span class="t-f12-c99">{{order.service_provider.name}}</span>
            <div class="display_flex m-t-15">
              <span class="t-f14-c66">实充电量</span>
              <span class="t-f14-c28 m-l-r-5">{{ order.total_power }}</span>
              <span class="t-f14-c28">度</span>
            </div>
            <div class="display_flex">
              <span class="t-f14-c66">实缴金额</span>
              <span class="t-f14-cf19321 m-l-r-5">{{ order.amount }}</span>
              <span class="t-f14-cf19321">元</span>
            </div>
          </div>
        </div>
      </div>
    </van-index-bar>
    <div class="bottom-container display_flex">
      <div class="display_flex all-seletct" @click="selectAll">
        <block>
          <img
            src="@/images/payment_unselected.png"
            class="select-icon"
            v-if="!orderCheckAll"
          />
          <img
            src="@/images/payment_selected.png"
            class="select-icon"
            v-if="orderCheckAll"
          />
        </block>
        <span class="t-f14-c0082FF m-l-10">全选</span>
      </div>
      <div class="sure-container">
        <div class="display_flex">
          <span class="t-f14-c66">实缴金额</span>
          <span class="t-f14-cf19321 m-l-5 font-bold"
            >{{ ordersTotal.toFixed(2) }}元</span
          >
        </div>
        <div class="display_flex m-t-5">
          <span class="t-f12-c66">共</span>
          <span class="t-f12-c0082FF m-5-l-r">{{ selectedList.length }}</span>
          <span class="t-f12-c66">个订单</span>
        </div>
      </div>
      <div class="btn">
        <van-button
          type="primary"
          size="normal"
          class="main-btn"
          @click="toTitleList"
          >下一步</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import request from "@/api/request";
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
let monthList; //月份容器;
let state = reactive({
  ordersList: [], //可开发票订单
});
let selectedList  //已选订单
let orderCheckAll  ////是否全选所有订单
let ordersTotal  //订单总价
let router;

let storeContext;
export default {
  components: {
    NavBar,
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  unmounted() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      monthList = ref([]); //月份容器;
      state = reactive({
        ordersList: [], //可开发票订单
      });
      selectedList = ref([]); //已选订单
      orderCheckAll = ref(false); ////是否全选所有订单
      ordersTotal = ref(0); //订单总价
      router.back();
    },
  },
  setup() {
    monthList = ref([])
    selectedList = ref([])
    ordersTotal = ref(0)
    router = useRouter();
    orderCheckAll = ref(false)
    storeContext = useStore();

    if (ordersTotal.value == 0) {
      //get request
      requestApi();
    }
    return {
      indexList: [],
      monthList,
      state,
      selectItem,
      selectMonth,
      selectedList,
      orderCheckAll,
      ordersTotal,
      toTitleList,
      router,
      selectAll,
    };
  },
};
function requestApi() {
  request
    .getReceiptOrders("")
    .then((res) => {
      state.ordersList = sort(sortReceipts(res.data));
    })
  
}
//确认页面
function toTitleList() {
  storeContext.commit("setInvoices", {
    invoicesList: selectedList.value,
    invoicesTotalNumber: ordersTotal.value,
  });
  router.push("/user/receipt/title_list");
}
//单选     selectedList:[],//已选订单  ordersTotal: 0//订单总价
function selectItem(monthId, itemId) {
  state.ordersList[monthId].data[itemId].isItemSelected = !state.ordersList[
    monthId
  ].data[itemId].isItemSelected;
  if (state.ordersList[monthId].data[itemId].isItemSelected) {
    //打勾
    selectedList.value.push(state.ordersList[monthId].data[itemId]); //添加订单
  } else {
    for (var i = 0; i < selectedList.value.length; i++) {
      if (
        selectedList.value[i].trade_number ==
        state.ordersList[monthId].data[itemId].trade_number
      ) {
        selectedList.value.splice(i, 1); //移除订单
      }
    }
  }
  var itemData = state.ordersList[monthId].data;
  var j = 0;
  for (let i = 0; i < itemData.length; i++) {
    j = itemData[i].isItemSelected ? j + 1 : 0;
    state.ordersList[monthId].isMonthSelect = j == itemData.length; //月份是否全选
  }
  checkOrderisAll(); //订单是否全选
}
//全选
function selectAll() {
  var list = state.ordersList;
  selectedList.value.splice(0, selectedList.value.length);
  for (var i = 0; i < list.length; i++) {
    list[i].isMonthSelect = !orderCheckAll.value; //月份是否选择根据全选是否打勾
    for (var j = 0; j < list[i].data.length; j++) {
      list[i].data[j].isItemSelected = !orderCheckAll.value;
      if (!orderCheckAll.value) {
        selectedList.value.push(list[i].data[j]);
      }
    }
  }
  computeOrdersTotal(); //计算价格/

  orderCheckAll.value = !orderCheckAll.value; //全选按钮反旋
}
//计算价格
function computeOrdersTotal() {
  ordersTotal.value = 0;
  for (var i = 0; i < selectedList.value.length; i++) {
    //计算价格
    ordersTotal.value =
      parseFloat(ordersTotal.value) + parseFloat(selectedList.value[i].amount);
  }
}
//整合编辑并且排列数据
function sort(data) {
  var arr = [];
  var mon = [];
  data.forEach(function (item, i) {
    var tmpDate = new Date(item.completed_at);
    var month = tmpDate.getMonth() + 1;
    var year = tmpDate.getFullYear();
    //   var tmpMonth = tmpDate.getMonth() + 1;
    // item.time = getApp().util.formatTimePayment(item.completed_at)
    item.amount = Math.abs(item.amount);
    // item.payment.reward_amount = Math.abs(item.payment.reward_amount);
    item.isItemSelected = false;
    if (i === 0) {
      var tmpObj = {};
      tmpObj.monthBar = year + "年" + month + "月";
      tmpObj.isMonthSelect = false;
      tmpObj.data = [];
      tmpObj.data.push(item);
      arr.push(tmpObj);
      mon.push(tmpObj.monthBar);
    } else {
      if (arr[arr.length - 1]["monthBar"] === year + "年" + month + "月") {
        arr[arr.length - 1]["data"].push(item);
      } else {
        let tmpObj = {};
        tmpObj.monthBar = year + "年" + month + "月";
        tmpObj.isMonthSelect = false;
        tmpObj.data = [];
        tmpObj.data.push(item);
        arr.push(tmpObj);
        mon.push(tmpObj.monthBar);
      }
    }
  });
  monthList.value = mon;
  return arr;
}
//选择月
function selectMonth(monthId) {
  var itemData = state.ordersList[monthId].data;
  state.ordersList[monthId].isMonthSelect = !state.ordersList[monthId]
    .isMonthSelect;
  for (var i = 0; i < itemData.length; i++) {
    itemData[i].isItemSelected = state.ordersList[monthId].isMonthSelect;
    if (state.ordersList[monthId].isMonthSelect) {
      //月份打勾
      selectedList.value.push(state.ordersList[monthId].data[i]);
      selectedList.value = ifIdentical(selectedList.value);
    } else {
      selectedList.value = array_difference(selectedList.value, itemData);
    }
  }
  checkOrderisAll(); //订单是否全选
}
//排序 大到小
function sortReceipts(data) {
  function sequence(a, b) {
    return parseInt(b.completed_at) - parseInt(a.completed_at);
  }
  return data.results.sort(sequence);
}
//检查是否订单全选
function checkOrderisAll() {
  var selectedMonth = 0;
  for (var i = 0; i < state.ordersList.length; i++) {
    selectedMonth = state.ordersList[i].isMonthSelect ? selectedMonth + 1 : 0;
    orderCheckAll.value = selectedMonth == state.ordersList.length;
  }
  computeOrdersTotal(); //计算价格
}
//判断是否有相同订单
function ifIdentical(a) {
  var r = [];
  for (var i = 0; i < a.length; i++) {
    var flag = true;
    var temp = a[i];
    for (var j = 0; j < r.length; j++) {
      if (temp.trade_number === r[j].trade_number) {
        flag = false;
        break;
      }
    }
    if (flag) {
      r.push(temp);
    }
  }
  return r;
}
//差集
function array_difference(a, b) {
  // 差集 a - b
  var clone = a.slice(0);
  for (var i = 0; i < b.length; i++) {
    var temp = b[i];
    for (var j = 0; j < clone.length; j++) {
      if (temp.trade_number === clone[j].trade_number) {
        clone.splice(j, 1);
      }
    }
  }
  return ifIdentical(clone);
}
</script>


<style scoped lang="scss">
.main-btn {
  height: 36px;
}
.btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.sure-container {
  position: relative;
  padding: 15px;
}
.all-seletct {
  border-right: 1px solid #ebebeb;
  width: 90px;
  padding-left: 30px;
  align-items: center;
}
.container {
  position: relative;
}
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 66px;
  border-top: 1px solid #ebebeb;
  background: #fff;
  z-index: 999;
}
.title-container {
  background: #f5f5f5;
  height: 40px;
  line-height: 40px;
  padding: 0px 30px;
}
.time-v {
  display: flex;
  align-items: center;
}
.select-icon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  vertical-align: middle;
}
.date-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  flex-shrink: 0;
  margin-left: 10px;
}
.item-container {
  background: #fff;
  padding: 10px 30px;
  border-bottom: 1px #ebebeb solid;
}
.line {
  background: #ebebeb;
  height: 1px;
  margin-top: 10px;
  margin-left: 30px;
}
.orders-info {
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-left: 25px;
}
::v-deep.van-index-anchor {
  padding: 0px;
}
</style>